<template>
  <h1>404 Not Found</h1>
  <h2></h2>
</template>

<script>
export default {
    name: 'NotFound',
}
</script>

<style scoped>
h1{
    text-align: center;
}
</style>